import { BaseModel, PaginationDataModel, convertToArrayModels, convertToModel, registerModel } from '~/shared/model'
import { isUnknownObject } from '~/shared/utils/guards'
import type { PaginationData } from '~/shared/interfaces'
import DigitalLectureVideoCard from '../detail/DigitalLectureVideoCard'

export default class DigitalLectureVideoListResult extends BaseModel {
  static override constructorName = 'DigitalLectureVideoListResult'

  items: DigitalLectureVideoCard[] = []
  pagination: PaginationData = new PaginationDataModel()

  constructor(data?: unknown) {
    super(data)
    if (isUnknownObject(data)) {
      this.items = convertToArrayModels(data.data, DigitalLectureVideoCard)

      this.pagination = convertToModel(data.meta, PaginationDataModel, this.pagination)
    }
  }
}

registerModel(DigitalLectureVideoListResult)
